import styles from "./Button.module.css";

// TODO: Implement outline & flat designs
// TODO: Implement disabled & fullWidth props
export interface ButtonProps {
  /**
   * Is this button been able to submit a form or not.
   */
  type?: "button" | "submit";
  /**
   * Which color should the button have?
   */
  color?: "primary";
  /**
   * Which design should the button have?
   */
  design?: "solid" | "outline" | "flat" | "link";
  /**
   * Is the button disabled?
   */
  disabled?: boolean;
  /**
   * Should the button be displayed width 100%?
   */
  fullWidth?: boolean;
  /**
   * How large should the button be?
   */
  size?: "small" | "medium" | "large";
  /**
   * Button contents
   */
  children: string | JSX.Element;
  /**
   * Optional click handler
   */
  onClick?: () => void;
}

const BASE_CLASS: string = "f-AtomButton";

const getClass = (
  baseClass: string,
  modifierLabel?: string,
  modifier?: string
) =>
  styles[
    `${baseClass}${
      Boolean(modifierLabel && modifier) ? `--${modifierLabel}-${modifier}` : ""
    }`
  ];

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  type = "button",
  color = "primary",
  design = "solid",
  size = "medium",
  children,
  onClick,
}: ButtonProps) => {
  const classNames = [
    getClass(BASE_CLASS),
    getClass(BASE_CLASS, "color", color),
    getClass(BASE_CLASS, "design", design),
    getClass(BASE_CLASS, "size", size),
  ].join(" ");

  return (
    <button className={classNames} {...{ type, onClick }}>
      {children}
    </button>
  );
};
